<template>
  <div class="flex-grow-1 d-flex flex-column">
    списочег
  </div>
</template>

<script>
  import moment from 'moment'
  import api from '@/api'

  export default {
    metaInfo: {title: 'Оплаты и баланс'},
    data () {
      return {
        filtersValue: null,
        data: {},
        loading: false,
        hasMore: true,
        sort: {prop: 'updated_at', order: 'asc'},
        updateList: 0,
        externalFilters: null,
        date: {
          min: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          max: moment().format('YYYY-MM-DD'),
        },
        regionFilters: [],
        statusFilters: [
          {value: 'succeeded', text: 'Успешно'},
          {value: 'pending', text: 'Ожидание'},
          {value: 'canceled', text: 'Прервано'},
          {value: 'adminPay', text: 'Биллинг'},
        ],
      }
    },
    computed: {
      payments () {
        return this.data.data
      },
    },
    methods: {
      loadMore () {
        this.$refs.data.loadMore()
      },
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          this.sort = {
            prop: sort.prop,
            order,
          }
        } else {
          this.sort = null
        }
      },
      filterChange (filter) {
        this.externalFilters = filter
      },
    },
    asyncComputed: {
      filters () {
        api.get('regions/options', {
          params: {field: 'short_name'},
        }).then(data => {
            console.log(data)
          this.regionFilters = data.data.data.map((el) => {
            return {
              value: el.id,
              text: el.short_name,
            }
          })
        })
      },
    }
  }
</script>

<style lang="scss">
.page-billing-pab tbody tr{
  cursor: pointer;
  }
.page-billing-pab .el-table_1_column_4 div,
.page-billing-pab .el-table_1_column_6 div{
  text-align: right;
}
.page-billing-pab .el-table_1_column_5 div{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/billing/organizations/list.vue